export const QTY_STEP = 1;
export const QTY_MIN = 1;

export const isValidQuantity = (qty) => qty >= QTY_MIN;

export const snapToValidQty = (qty) => Math.max(QTY_MIN, Math.round(qty));

export const validateCart = (subtotal) => {
  if (subtotal === 0) return { valid: false, message: "Your cart is empty." };
  return { valid: true, message: null };
};
